import React, { useEffect } from "react";
import SEO from "../components/SEO"
import Layout from "../components/Layout"
import WorkerLandingPage from "../components/landing-page/WorkerLandingPage";

import { useRouter } from 'next/router'
import Head from "next/head"

import { WPPagesAPI } from "../lib/conduit"
import WPParser from "../lib/parsePage"
import parse from 'html-react-parser'

export async function getServerSideProps(context) {
  const {text} = await WPPagesAPI.workers()

  const page = new WPParser(text)

  const pageBody = page.body
  const pageHead = page.head
  const pageTitle = page.title
  const bodyClass = page.bodyClass

  return {
    props: {
      page: {
        title: pageTitle,
        head: pageHead,
        content: pageBody,
        bodyClass,
      },
    },
  }
}

export default function Home({page}) {
  return (
    <Layout lander={true} WP classList={page.bodyClass}>
      <Head>
        {parse(page.head)}
      </Head>
      <SEO title={page.title} path="/" override={true}/>
      <WorkerLandingPage page={page} />
    </Layout>
  )
}